import { fetchFormData, postWithCache } from "../../helpers/backend_helper";
import { COMMON } from "../../helpers/url_helper";
import {
  FETCH_DIVISIONS_FAILURE,
  FETCH_DIVISIONS_SUCCESS,
  FETCH_REGIONS_FAILURE,
  FETCH_REGIONS_SUCCESS,
  FETCH_ROLES_FAILURE,
  FETCH_ROLES_SUCCESS,
  GENERATE_PRESIGNED_URL,
  GET_ALL_GUARD_LOCATIONS,
  GET_NOTIFICATION,
  POST_GENERATE_PRESIGNED_URL,
  READ_NOTIFICATION,
  SAVE_ALL_GUARD_LOCATIONS,
  SAVE_NOTIFICATION,
  FETCH_RANGES_FAILURE,
  FETCH_RANGES_SUCCESS,
  FETCH_ROUNDS_FAILURE,
  FETCH_ROUNDS_SUCCESS,
  FETCH_BEATS_FAILURE,
  FETCH_BEATS_SUCCESS,
  FETCH_COMPARTMENTS_FAILURE,
  FETCH_COMPARTMENTS_SUCCESS,
  GET_ALL_BEATS_LOCATIONS,
  GET_ALL_VEHICLE_LOCATIONS,
  SAVE_ALL_VEHICLE_LOCATIONS,
  SAVE_ALL_BEATS_LOCATIONS,
  GET_ALL_USER,
  SAVE_ALL_USER,
} from "./actionTypes";


export const getAllGuardLocations = () => ({
  type: GET_ALL_GUARD_LOCATIONS,
});
export const getAllBeatswithChargeGaurd = () => ({
  type: GET_ALL_BEATS_LOCATIONS,
});
export const getAllVehicleLocation = () => ({
  type: GET_ALL_VEHICLE_LOCATIONS,
});

export const getAllUSer = (users) => ({
  type: GET_ALL_USER,
  payload:users
});

export const saveAllUsernVehicle = (users) => ({
  type: SAVE_ALL_USER,
  payload:users
});


export const saveGuardLocations = (locations) => ({
  type: SAVE_ALL_GUARD_LOCATIONS,
  payload: locations,
});
export const saveBeatsLocations = (locations) => ({
  type: SAVE_ALL_BEATS_LOCATIONS,
  payload: locations,
});
export const saveVehicleLocations = (locations) => ({
  type: SAVE_ALL_VEHICLE_LOCATIONS,
  payload: locations,
});

export const getMyNotification = (page, limit) => ({
  type: GET_NOTIFICATION,
  payload: { page, limit },
});
export const readMyNotification = (timestamp) => ({
  type: READ_NOTIFICATION,
  payload: timestamp,
});

export const postNotification = (notifications) => ({
  type: SAVE_NOTIFICATION,
  payload: notifications,
});

export const generatePresignedUrl = (payload) => ({
  type: GENERATE_PRESIGNED_URL,
  payload,
});

export const postGeneratePresignedUrl = (url) => ({
  type: POST_GENERATE_PRESIGNED_URL,
  payload: url,
});

export const fetchRoles = () => async (dispatch) => {
  try {
    // Extract incident location if present

    // Create payload with structured location data
    const payload = {
      act: "common",
      subact: "getAllRoles",
      info: {},
    };

    // Remove the raw incident location field
    // delete payload.info.incidentLocation;

    const response = await postWithCache(payload,COMMON);

    if (response.message.includes("success")) {
      dispatch({
        type: FETCH_ROLES_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: FETCH_ROLES_FAILURE,
        error: response.message,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_ROLES_FAILURE,
      error: "Error fetching regions",
    });
  }
};
export const fetchDivisions = () => async (dispatch) => {
  try {
    const payload = {
      act: "common",
      subact: "getAllDivision",
      info: {},
    };
    const response = await postWithCache(payload,COMMON);

    if (response.message.includes("success")) {
      dispatch({
        type: FETCH_DIVISIONS_SUCCESS,
        payload: response,
      });
    } else {
      dispatch({
        type: FETCH_DIVISIONS_FAILURE,
        error: response.message,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_DIVISIONS_FAILURE,
      error: "Error fetching divisions",
    });
  }
};
export const fetchRegions = () => async (dispatch) => {
  try {
    const payload = {
      act: "common",
      subact: "getAllRegions",
      info: {},
    };

    const response = await postWithCache(payload,COMMON);

    if (response.message.includes("success")) {
      dispatch({
        type: FETCH_REGIONS_SUCCESS,
        payload: response,
      });
    } else {
      dispatch({
        type: FETCH_REGIONS_FAILURE,
        error: response.message,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_REGIONS_FAILURE,
      error: "Error fetching regions",
    });
  }
};

// 🔹 Fetch Ranges based on Division
export const fetchRanges = (divisionId) => async (dispatch) => {
  try {
    const payload = { act: "common", subact: "getAllRanges", info: {search: {divisionId:divisionId},
   "requiredAtt":["divisionId", "name", "rangeName","rangeId"] } };
    const response = await postWithCache(payload,COMMON);

    if (response.message.includes("success")) {
      dispatch({ type: FETCH_RANGES_SUCCESS, payload: response });
    } else {
      dispatch({ type: FETCH_RANGES_FAILURE, error: response.message });
    }
  } catch (error) {
    dispatch({ type: FETCH_RANGES_FAILURE, error: "Error fetching ranges" });
  }
};
export const fetchRanges2 = (divisionId) => async (dispatch) => {
  try {
    const payload = {
      act: "common",
      subact: "getAllRanges",
      info: {
        search: { divisionId: divisionId },
        requiredAtt: [
          "divisionId",
          "name",
          "rangeName",
          "rangeId",
          "coordinates",
        ],
      },
    };
    const response = await postWithCache(payload,COMMON);

    if (response.message.includes("success")) {
      dispatch({ type: FETCH_RANGES_SUCCESS, payload: response });
    } else {
      dispatch({ type: FETCH_RANGES_FAILURE, error: response.message });
    }
  } catch (error) {
    dispatch({ type: FETCH_RANGES_FAILURE, error: "Error fetching ranges" });
  }
};

// 🔹 Fetch Rounds based on Range
export const fetchRounds = (rangeId) => async (dispatch) => {
  try {
    const payload = {
      act: "common",
      subact: "getAllRounds",
      info: {
        search: { rangeId: rangeId },
        requiredAtt: ["roundId", "name", "roundName", "rangeId"],
      },
    };
    const response = await postWithCache(payload,COMMON);

    if (response.message.includes("success")) {
      dispatch({ type: FETCH_ROUNDS_SUCCESS, payload: response });
    } else {
      dispatch({ type: FETCH_ROUNDS_FAILURE, error: response.message });
    }
  } catch (error) {
    dispatch({ type: FETCH_ROUNDS_FAILURE, error: "Error fetching rounds" });
  }
};
export const fetchRounds2 = (rangeId) => async (dispatch) => {
  try {
    const payload = {
      act: "common",
      subact: "getAllRounds",
      info: {
        search: { rangeId: rangeId },
        requiredAtt: ["roundId", "name", "roundName", "rangeId","coordinates"],
      },
    };
    const response = await postWithCache(payload,COMMON);

    if (response.message.includes("success")) {
      dispatch({ type: FETCH_ROUNDS_SUCCESS, payload: response });
    } else {
      dispatch({ type: FETCH_ROUNDS_FAILURE, error: response.message });
    }
  } catch (error) {
    dispatch({ type: FETCH_ROUNDS_FAILURE, error: "Error fetching rounds" });
  }
};

// 🔹 Fetch Beats based on Round
export const fetchBeats = (roundId) => async (dispatch) => {
  try {
    const payload = {
      act: "common",
      subact: "getAllBeats",
      info: {
        search: { roundId: roundId },
        requiredAtt: ["roundId", "name","beatName", "beatId"],
      },
    };
    const response = await postWithCache(payload,COMMON);

    if (response.message.includes("success")) {
      dispatch({ type: FETCH_BEATS_SUCCESS, payload: response });
    } else {
      dispatch({ type: FETCH_BEATS_FAILURE, error: response.message });
    }
  } catch (error) {
    dispatch({ type: FETCH_BEATS_FAILURE, error: "Error fetching beats" });
  }
};

// 🔹 Fetch Compartments based on Beat
export const fetchCompartments = (beatId) => async (dispatch) => {
  try {
    const payload = { act: "common", subact: "getAllCompt", info: { search: { beatId: Number(beatId) },        requiredAtt: [ "name","compId","beatName", "beatId"],
  } };
    const response = await fetchFormData(payload);

    if (response.message.includes("success")) {
      dispatch({ type: FETCH_COMPARTMENTS_SUCCESS, payload: response });
    } else {
      dispatch({ type: FETCH_COMPARTMENTS_FAILURE, error: response.message });
    }
  } catch (error) {
    dispatch({ type: FETCH_COMPARTMENTS_FAILURE, error: "Error fetching compartments" });
  }
};

